import React, { useState, useCallback } from "react";
import CSHDialog from "./CSHDialog";

// Custom hook to show CSHDialog and get result as a promise
export function useCSHDialog() {
  const [dialogProps, setDialogProps] = useState(null);

  const showDialog = useCallback(
    (options) =>
      new Promise((resolve, reject) => {
        setDialogProps({
          ...options,
          isOpen: true,
          onSubmit: (value) => {
            setDialogProps(null);
            resolve(value);
          },
          onCancel: () => {
            setDialogProps(null);
            resolve(null);
          },
        });
      }),
    []
  );

  const dialog = dialogProps ? <CSHDialog {...dialogProps} /> : null;

  return [showDialog, dialog];
}